import { render, staticRenderFns } from "./ExchangeRow.vue?vue&type=template&id=6703b45a&"
import script from "./ExchangeRow.vue?vue&type=script&lang=ts&"
export * from "./ExchangeRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports